/**
 * @license
 * Copyright (c) %FIRST_YEAR% %CURRENT_YEAR%, Oracle and/or its affiliates. All rights reserved.
 * https://www.oracle.com/contracts/docs/cloud_csa_online_v062223_us_eng.pdf?download=false&er=221886
 * @ignore
 */
// DO NOT MODIFY THIS FILE MANUALLY!
// This file is automatically generated based on the corresponding SVG image in
// the packages/oraclejet-preact/resources/icons folder.
import { ComponentProps } from 'preact';
import { Icon } from '../../UNSAFE_Icon';
type Props = Omit<ComponentProps<typeof Icon>, 'viewBox' | 'children'>;
const SvgAccessorOne = (props: Props) => (
  <Icon viewBox="0 0 24 24" {...props}>
    <path
      d="M5 9a3 3 0 1 1-.001 6.001A3 3 0 0 1 5 9zm14 0a3 3 0 1 1-.001 6.001A3 3 0 0 1 19 9zM5 11a1 1 0 1 0 .001 2.001A1 1 0 0 0 5 11zm14 0a1 1 0 1 0 .001 2.001A1 1 0 0 0 19 11zm-5 0v2h-4v-2z"
      fill="currentcolor"
      fillRule="evenodd"
    />
  </Icon>
);
export { SvgAccessorOne as AccessorOne };
